import { ISubmitInquiryProps } from '@interfaces/inquiries';

export const buildSubmitInquiryPayload = ({ inquiryId, inquiryName }: ISubmitInquiryProps) => ({
  id: inquiryId,
  inquiryName,
});
